import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
// import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faProjects, faTrello, faUsers, faLayerGroup, faFileAlt, faClipboardList, faRunning, faTasks, faExclamationCircle, faDollarSign, faCalendarAlt, faFile, faComment, faProjectDiagram, faClipboard, faPieChart } from '@fortawesome/free-solid-svg-icons';

import './SprintCentral.css';
import sprintcentralimage from '../../assets/pageimages/SprintCentral.webp';

function SprintCentralHome() {

  return (
    <div>
       <div className="p-4 sm:p-6 lg:p-8">
        <h2 className="text-2xl font-bold text-white border-b border-b-gray-300 mb-4">Sprint Central</h2>
        
        <div className="flex flex-row justify-center mb-4">
          <img 
            id="sprintcentral-id" 
            src={sprintcentralimage} 
            alt="SprintCentral Image" 
            className="w-full sm:w-1/2 md:w-1/3 object-cover rounded-lg shadow-lg"
          />
        </div>

        <div className="bg-gray-700 rounded-lg shadow-lg p-4">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            <div className="flex items-center justify-center p-2">
              <Link to="/sprintcentral-threepf" className="flex items-center w-full bg-blue-400 rounded-lg shadow-lg py-2 px-2 text-white hover:text-gray-300">
                <FontAwesomeIcon icon={faPieChart} className="mr-2" />
                Three Points Formula
              </Link>
            </div>
            <div className="flex items-center justify-center p-2">
              <Link to="/sprintcentral-projects" className="flex items-center w-full bg-blue-400 rounded-lg shadow-lg py-2 px-2 text-white hover:text-gray-300">
                <FontAwesomeIcon icon={faProjectDiagram} className="mr-2" />
                Projects
              </Link>
            </div>
            <div className="flex items-center justify-center p-2">
              <Link to="/sprintcentral-agile-board" className="flex items-center w-full bg-blue-400 rounded-lg shadow-lg py-2 px-2 text-white hover:text-gray-300">
                <FontAwesomeIcon icon={faClipboard} className="mr-2" />
                Agile Board
              </Link>
            </div>
            <div className="flex items-center justify-center p-2">
              <Link to="/sprintcentral-team-list" className="flex items-center w-full bg-blue-400 rounded-lg shadow-lg py-2 px-2 text-white hover:text-gray-300">
                <FontAwesomeIcon icon={faUsers} className="mr-2" />
                Agile Team
              </Link>
            </div>
            <div className="flex items-center justify-center p-2">
              <Link to="/sprintcentral-epic-list" className="flex items-center w-full bg-blue-400 rounded-lg shadow-lg py-2 px-2 text-white hover:text-gray-300">
                <FontAwesomeIcon icon={faLayerGroup} className="mr-2" />
                Epic
              </Link>
            </div>
            <div className="flex items-center justify-center p-2">
              <Link to="/sprintcentral-story-list" className="flex items-center w-full bg-blue-400 rounded-lg shadow-lg py-2 px-2 text-white hover:text-gray-300">
                <FontAwesomeIcon icon={faFileAlt} className="mr-2" />
                Story
              </Link>
            </div>
            <div className="flex items-center justify-center p-2">
              <Link to="/sprintcentral-create-backlog" className="flex items-center w-full bg-blue-400 rounded-lg shadow-lg py-2 px-2 text-white hover:text-gray-300">
                <FontAwesomeIcon icon={faClipboardList} className="mr-2" />
                Backlog
              </Link>
            </div>
            <div className="flex items-center justify-center p-2">
              <Link to="/sprintcentral-create-sprint" className="flex items-center w-full bg-blue-400 rounded-lg shadow-lg py-2 px-2 text-white hover:text-gray-300">
                <FontAwesomeIcon icon={faRunning} className="mr-2" />
                Sprint
              </Link>
            </div>
            <div className="flex items-center justify-center p-2">
              <Link to="/sprintcentral-create-task" className="flex items-center w-full bg-blue-400 rounded-lg shadow-lg py-2 px-2 text-white hover:text-gray-300">
                <FontAwesomeIcon icon={faTasks} className="mr-2" />
                Task
              </Link>
            </div>
            <div className="flex items-center justify-center p-2">
              <Link to="/sprintcentral-create-issue" className="flex items-center w-full bg-blue-400 rounded-lg shadow-lg py-2 px-2 text-white hover:text-gray-300">
                <FontAwesomeIcon icon={faExclamationCircle} className="mr-2" />
                Issue
              </Link>
            </div>
            <div className="flex items-center justify-center p-2">
              <Link to="/sprintcentral-enter-cost" className="flex items-center w-full bg-blue-400 rounded-lg shadow-lg py-2 px-2 text-white hover:text-gray-300">
                <FontAwesomeIcon icon={faDollarSign} className="mr-2" />
                Cost
              </Link>
            </div>
            <div className="flex items-center justify-center p-2">
              <Link to="/sprintcentral-create-meeting" className="flex items-center w-full bg-blue-400 rounded-lg shadow-lg py-2 px-2 text-white hover:text-gray-300">
                <FontAwesomeIcon icon={faCalendarAlt} className="mr-2" />
                Agile Meetings
              </Link>
            </div>
            <div className="flex items-center justify-center p-2">
              <Link to="/sprintcentral-document-create" className="flex items-center w-full bg-blue-400 rounded-lg shadow-lg py-2 px-2 text-white hover:text-gray-300">
                <FontAwesomeIcon icon={faFile} className="mr-2" />
                Documents
              </Link>
            </div>
            <div className="flex items-center justify-center p-2">
              <Link to="/sprintcentral-message-create" className="flex items-center w-full bg-blue-400 rounded-lg shadow-lg py-2 px-2 text-white hover:text-gray-300">
                <FontAwesomeIcon icon={faComment} className="mr-2" />
                Communications
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SprintCentralHome;
